import { Link, MessageBar, MessageBarType } from '@fluentui/react';
import React, {
    PropsWithChildren,
    useCallback,
    useEffect,
    useState,
} from 'react';
import { getBannerData } from '../../../Common/api/ABHub/BannerApi';
import { CancelToken } from 'axios';
import { usePromise } from '../../../Common/hooks/usePromise';
import { Banner } from '../../../Common/models/Banner';

interface IMessageBarProps extends PropsWithChildren<any> {}

export const GeneralMessageBar: React.FC<IMessageBarProps> = (
    props: IMessageBarProps
) => {
    const fetchMessages = useCallback(async (cancelToken?: CancelToken) => {
        const bannerMessages = await getBannerData(cancelToken);

        return bannerMessages;
    }, []);

    const [bannerMessages, error, isLoaded] = usePromise(fetchMessages, true);

    const [banners, setBanners] = useState<Banner[]>([]);

    const dismissGeneralEgressMessage = (banner: Banner) => {
        if (banners && banners.length > 0) {
            const updatedBannerMessages = banners.map((message) => {
                if (message.id === banner.id) {
                    return {
                        ...message,
                        isDismissed: true,
                    };
                } else {
                    return message;
                }
            });

            setBanners(updatedBannerMessages);
        }
    };

    const getMessageBarType = (type: string) => {
        switch (type) {
            case 'General':
                return MessageBarType.info;
            case 'Warning':
                return MessageBarType.warning;
            case 'Error':
                return MessageBarType.error;
        }
    };

    const isValidDate = (startDate: Date, endDate: Date) => {
        const now = new Date();
        const converetedStartDate = new Date(startDate); // Convert to proper format
        const convertedEndDate = new Date(endDate); // Convert to proper format

        return (
            now.getTime() > converetedStartDate.getTime() &&
            now.getTime() < convertedEndDate.getTime()
        );
    };

    useEffect(() => {
        if (bannerMessages && bannerMessages.length > 0) {
            setBanners(bannerMessages);
        }
    }, [bannerMessages, error]);

    return (
        <div className="MessageBar-root" style={{ zIndex: 1 }}>
            {banners.map(
                (line, index) =>
                    line.isActive &&
                    !line.isDismissed &&
                    isValidDate(line.startDate, line.endDate) && (
                        <MessageBar
                            key={index}
                            messageBarType={getMessageBarType(
                                line.typeString ?? 'General'
                            )}
                            isMultiline={true}
                            onDismiss={() => dismissGeneralEgressMessage(line)}
                            dismissButtonAriaLabel="Close"
                        >
                            <div>
                                {line.message
                                    .split(
                                        /((?:https?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+)/g
                                    )
                                    .map((word, index) => {
                                        if (/^https?:\/\//.test(word)) {
                                            return (
                                                <Link
                                                    key={index}
                                                    href={word}
                                                    target="_blank" // opens in a new tab or window
                                                    rel="noopener noreferrer"
                                                >
                                                    {word}
                                                </Link>
                                            );
                                        } else {
                                            return (
                                                <span key={index}>{word} </span>
                                            );
                                        }
                                    })}
                            </div>
                        </MessageBar>
                    )
            )}
        </div>
    );
};
